module.exports = __webpack_public_path__ + "media/images/SW-HeritageCrest-Standard-BlueWhite-8cb0544a167e4e2bf8960c2b3190112a.svg";